import { useCallback } from "react";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import EditorialMarquee from "@/components/site/EditorialMarquee";
import About from "@/components/site/About";
import Services from "@/components/site/Services";
import Approach from "@/components/site/Approach";
import Testimonials from "@/components/site/Testimonials";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

export default function Landing() {
  const scrollToContact = useCallback(() => {
    const el = document.getElementById("contact");
    if (el) window.__lenis ? window.__lenis.scrollTo(el, { offset: -80 }) : el.scrollIntoView();
  }, []);

  return (
    <div data-testid="landing-page">
      <Navbar />
      <Hero onCta={scrollToContact} />
      <EditorialMarquee />
      <About />
      <Services />
      <Approach />
      <Testimonials />
      <Contact />
      <Footer />
    </div>
  );
}
